/* Shared delivery-method picker logic for sections/cart-template.liquid and
   snippets/cart-drawer.liquid. Reads variant IDs from data-* attributes
   (resolved server-side from the 'pakomats' product) instead of hardcoding
   them, so recreating that product in Shopify surfaces a clear error instead
   of silently breaking checkout.

   Shipping choice must always land on the order as cart attributes. Shopify
   keeps stale attributes until they are explicitly cleared with "", so every
   method write clears the other method's keys. Omniva always writes Pakomāts
   (and mirrors) so Admin "Additional details" shows the selected locker. */
(function () {
  if (window.AIOOShippingPicker) return;

  var ATTR_PAKOMATS = 'Pakomāts';
  var ATTR_OMNIVA = 'omniva_pakomats';
  var ATTR_TERMINAL = 'parcel_terminal';
  var ATTR_PIEGADE = 'Piegāde';
  var ATTR_STORE = 'Saņemšanas veikals';
  var ATTR_PIEGADES_VEIDS = 'Piegādes veids';

  function emptyAttrs() {
    var attrs = {};
    attrs[ATTR_PAKOMATS] = '';
    attrs[ATTR_OMNIVA] = '';
    attrs[ATTR_TERMINAL] = '';
    attrs[ATTR_PIEGADE] = '';
    attrs[ATTR_STORE] = '';
    attrs[ATTR_PIEGADES_VEIDS] = '';
    return attrs;
  }

  function noteWithPakomats(existingNote, terminal) {
    var base = String(existingNote || '')
      .replace(/\n?Pakomāts:\s*.+$/gim, '')
      .replace(/\n?Omniva pakomāts:\s*.+$/gim, '')
      .replace(/\n?Veikals:\s*.+$/gim, '')
      .trim();
    var line = 'Pakomāts: ' + terminal;
    return base ? base + '\n' + line : line;
  }

  function noteWithStore(existingNote, store) {
    var base = String(existingNote || '')
      .replace(/\n?Pakomāts:\s*.+$/gim, '')
      .replace(/\n?Omniva pakomāts:\s*.+$/gim, '')
      .replace(/\n?Veikals:\s*.+$/gim, '')
      .trim();
    var line = 'Veikals: ' + store;
    return base ? base + '\n' + line : line;
  }

  function noteWithoutPakomats(existingNote) {
    return String(existingNote || '')
      .replace(/\n?Pakomāts:\s*.+$/gim, '')
      .replace(/\n?Omniva pakomāts:\s*.+$/gim, '')
      .replace(/\n?Veikals:\s*.+$/gim, '')
      .trim();
  }

  function sweepStaleShippingVariants(container) {
    var ids = [
      container.dataset.omnivaVariantId,
      container.dataset.courierVariantId,
      container.dataset.pickupVariantId
    ].filter(Boolean);

    if (!ids.length) return Promise.resolve();

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var updates = {};
        var idSet = {};
        ids.forEach(function (id) { idSet[String(id)] = true; });
        (cart.items || []).forEach(function (item) {
          if (idSet[String(item.variant_id)] || idSet[String(item.id)]) {
            updates[String(item.key || item.id)] = 0;
          }
        });
        if (!Object.keys(updates).length) return cart;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('cart/update.js ' + response.status);
          return response.json();
        });
      })
      .catch(function (err) {
        console.error('Shipping product removal failed:', err);
        /* Fall back to remove-button clicks for older cart markup. */
        ids.forEach(function (variantId) {
          document.querySelectorAll('.removeBtn[data-variant-id="' + variantId + '"]').forEach(function (button) {
            try { button.click(); } catch (e) {}
          });
        });
      });
  }

  function setPanelVisibility(container) {
    var omnivaTile = container.querySelector('[data-method="omniva"]');
    var courierTile = container.querySelector('[data-method="courier"]');
    var pickupTile = container.querySelector('[data-method="pickup"]');
    var omnivaSelect = container.querySelector('.shipping__Omniva__select');
    var courierTitle = container.querySelector('.shipping__Courier');
    var pickupTitle = container.querySelector('.shipping__StorePickup');

    if (omnivaSelect) omnivaSelect.style.display = (omnivaTile && omnivaTile.classList.contains('active')) ? 'block' : 'none';
    if (courierTitle) courierTitle.style.display = (courierTile && courierTile.classList.contains('active')) ? 'block' : 'none';
    if (pickupTitle) pickupTitle.style.display = (pickupTile && pickupTile.classList.contains('active')) ? 'block' : 'none';
    syncTileAria(container);
  }

  function syncTileAria(container) {
    container.querySelectorAll('.js-shipping-option').forEach(function (tile) {
      var active = tile.classList.contains('active');
      tile.setAttribute('aria-checked', active ? 'true' : 'false');
      tile.tabIndex = active ? 0 : -1;
    });
    var anyActive = container.querySelector('.js-shipping-option.active');
    if (!anyActive) {
      container.querySelectorAll('.js-shipping-option').forEach(function (tile, i) {
        tile.tabIndex = i === 0 ? 0 : -1;
      });
    }
  }

  function showInlineError(container, message) {
    var el = container.querySelector('[data-shipping-error]');
    if (!el) {
      if (message) window.alert(message);
      return;
    }
    if (!message) {
      el.textContent = '';
      el.hidden = true;
      return;
    }
    el.textContent = message;
    el.hidden = false;
    try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }

  function stopCartQtyBubble(event) {
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
  }

  function applyConfirmedState(container) {
    var method = container.dataset.confirmedMethod;
    if (!method) return false;

    var tiles = container.querySelectorAll('.js-shipping-option');
    tiles.forEach(function (el) { el.classList.remove('active'); });
    var tile = container.querySelector('[data-method="' + method + '"]');
    if (tile) tile.classList.add('active');

    if (method === 'omniva' && container.dataset.confirmedPakomats) {
      var select = container.querySelector('.js-parcel-terminal-select');
      if (select) select.value = container.dataset.confirmedPakomats;
    }
    if (method === 'pickup' && container.dataset.confirmedStore) {
      var storeSelect = container.querySelector('.js-store-pickup-select');
      if (storeSelect) storeSelect.value = container.dataset.confirmedStore;
    }

    setPanelVisibility(container);
    return true;
  }

  function isWarehouseStore(entry) {
    var blob = ((entry && (entry.name || '')) + ' ' + (entry.store || '') + ' ' + (entry.address || '')).toLowerCase();
    return (
      blob.indexOf('noliktav') !== -1 ||
      blob.indexOf('birojs') !== -1 ||
      blob.indexOf('warehouse') !== -1 ||
      blob.indexOf('rēzeknes iela 4') !== -1 ||
      blob.indexOf('rezeknes iela 4') !== -1
    );
  }

  function storeLabel(entry) {
    /* Prefer mall/venue (stores.json "store", O2O venue line, Shopify
       "T/C Damme") over internal "AIOO Damme" name so cart matches PDP/Admin. */
    var venue = String((entry && entry.store) || '').trim();
    var name = String((entry && entry.name) || '').trim();
    var address = String((entry && entry.address) || '').trim();
    var primary = venue || name;
    if (primary && address) return primary + ' — ' + address;
    return primary || address;
  }

  function storeMatchesConfirmed(label, entry, confirmed) {
    if (!confirmed) return false;
    if (confirmed === label) return true;
    var venue = String((entry && entry.store) || '').trim();
    var name = String((entry && entry.name) || '').trim();
    if (venue && confirmed.indexOf(venue) !== -1) return true;
    if (name && confirmed.indexOf(name) !== -1) return true;
    return false;
  }

  function populateStoreSelect(container) {
    var select = container.querySelector('.js-store-pickup-select');
    if (!select || select.dataset.aiooStoresLoaded === '1') return Promise.resolve();

    var url = container.dataset.storesUrl;
    if (!url) return Promise.resolve();

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('stores.json ' + r.status);
        return r.json();
      })
      .then(function (rows) {
        var confirmed = container.dataset.confirmedStore || '';
        var promptOpt = select.querySelector('option[value=""]');
        var promptText = promptOpt
          ? promptOpt.textContent
          : 'Lūdzu, izvēlieties veikalu...';
        var html = '<option value="">' + promptText + '</option>';
        var matchedLabel = '';
        (rows || []).forEach(function (entry) {
          if (!entry || isWarehouseStore(entry)) return;
          var label = storeLabel(entry);
          if (!label) return;
          var selected = storeMatchesConfirmed(label, entry, confirmed);
          if (selected) matchedLabel = label;
          html +=
            '<option value="' +
            label.replace(/"/g, '&quot;') +
            '"' +
            (selected ? ' selected' : '') +
            '>' +
            label +
            '</option>';
        });
        select.innerHTML = html;
        select.dataset.aiooStoresLoaded = '1';
        if (matchedLabel) select.value = matchedLabel;
      })
      .catch(function (err) {
        console.error('Failed to load stores.json:', err);
      });
  }

  function initSummaryToggle(container) {
    var summary = container.querySelector('[data-shipping-summary]');
    var full = container.querySelector('[data-shipping-full]');
    if (!summary || !full) return;
    var changeBtn = summary.querySelector('[data-shipping-change]');
    if (!changeBtn) return;
    changeBtn.addEventListener('click', function () {
      summary.hidden = true;
      full.hidden = false;
      sweepStaleShippingVariants(container);
    });
  }

  function initSelect2(container) {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.select2) return;
    var $select = window.jQuery(container).find('.js-parcel-terminal-select');
    if (!$select.length || $select.hasClass('select2-hidden-accessible')) return;
    $select.select2({
      width: '100%',
      placeholder: $select.attr('placeholder') || 'Izvēlies pakomātu',
      allowClear: false
    });
  }

  function init(container, options) {
    if (!container) return;
    options = options || {};

    if (!container.dataset.shippingPickerInit) {
      container.dataset.shippingPickerInit = '1';

      var isConfirmed = applyConfirmedState(container);
      if (!isConfirmed) {
        sweepStaleShippingVariants(container);
      }
      initSummaryToggle(container);
      initSelect2(container);
      populateStoreSelect(container);

      var tiles = container.querySelectorAll('.js-shipping-option');
      tiles.forEach(function (tile) {
        var activate = function () {
          showInlineError(container, '');
          tiles.forEach(function (el) { el.classList.remove('active'); });
          tile.classList.add('active');
          setPanelVisibility(container);
          if (tile.dataset.method === 'pickup') populateStoreSelect(container);
          if (typeof options.onMethodSelected === 'function') {
            options.onMethodSelected(tile.dataset.method);
          }
          if (options.persistOnSelect) {
            persistSelectionSoon(container);
          }
        };
        tile.addEventListener('click', activate);
        tile.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate();
        });
      });
      syncTileAria(container);

      var select = container.querySelector('.js-parcel-terminal-select');
      if (select && !select.dataset.aiooPersistBound) {
        select.dataset.aiooPersistBound = '1';
        select.classList.add('stopEv');
        var onTerminalChange = function (event) {
          stopCartQtyBubble(event);
          showInlineError(container, '');
          var omnivaTile = container.querySelector('[data-method="omniva"]');
          if (omnivaTile && !omnivaTile.classList.contains('active')) {
            container.querySelectorAll('.js-shipping-option').forEach(function (el) {
              el.classList.remove('active');
            });
            omnivaTile.classList.add('active');
            setPanelVisibility(container);
          }
          if (options.persistOnSelect) {
            persistSelectionSoon(container);
          }
        };
        select.addEventListener('change', onTerminalChange);
        select.addEventListener('click', stopCartQtyBubble);
        if (typeof window.jQuery !== 'undefined') {
          window.jQuery(select).on('select2:select select2:clear', onTerminalChange);
        }
      }

      var storeSelect = container.querySelector('.js-store-pickup-select');
      if (storeSelect && !storeSelect.dataset.aiooPersistBound) {
        storeSelect.dataset.aiooPersistBound = '1';
        storeSelect.classList.add('stopEv');
        storeSelect.addEventListener('change', function (event) {
          stopCartQtyBubble(event);
          showInlineError(container, '');
          var pickupTile = container.querySelector('[data-method="pickup"]');
          if (pickupTile && !pickupTile.classList.contains('active')) {
            container.querySelectorAll('.js-shipping-option').forEach(function (el) {
              el.classList.remove('active');
            });
            pickupTile.classList.add('active');
            setPanelVisibility(container);
          }
          if (options.persistOnSelect) {
            persistSelectionSoon(container);
          }
        });
        storeSelect.addEventListener('click', stopCartQtyBubble);
      }

      setPanelVisibility(container);
    } else {
      /* Section may have re-inited select2; keep panel state. */
      applyConfirmedState(container);
      initSelect2(container);
      populateStoreSelect(container);
      setPanelVisibility(container);
    }
  }

  var persistTimer = null;
  function persistSelectionSoon(container) {
    if (persistTimer) clearTimeout(persistTimer);
    persistTimer = setTimeout(function () {
      persistSelectionNow(container);
    }, 200);
  }

  function persistSelectionNow(container) {
    var result = collect(container);
    if (!result.ok) return;
    if (result.payload.method !== 'omniva' && result.payload.method !== 'pickup' && result.payload.method !== 'courier') {
      return;
    }
    /* Attributes + note only — full line-item swap happens on checkout submit. */
    updateCartAttributesAndNote(result.payload).catch(function (err) {
      console.error('Delivery choice live persist failed:', err);
    });
  }

  function collect(container) {
    var active = container.querySelector('.js-shipping-option.active');
    if (!active) {
      applyConfirmedState(container);
      active = container.querySelector('.js-shipping-option.active');
    }
    if (!active) {
      return { ok: false, message: 'Lūdzu, izvēlieties piegādes veidu!' };
    }

    var method = active.dataset.method;
    var cartAttributes = emptyAttrs();
    var data = null;
    var note = null;

    if (method === 'omniva') {
      var select = container.querySelector('.js-parcel-terminal-select');
      var selectedTerminal = select ? String(select.value || '').trim() : '';
      if (!selectedTerminal && container.dataset.confirmedPakomats) {
        selectedTerminal = String(container.dataset.confirmedPakomats).trim();
        if (select && selectedTerminal) select.value = selectedTerminal;
      }
      if (!selectedTerminal) {
        if (select) {
          try { select.focus(); } catch (e) {}
        }
        return { ok: false, message: container.dataset.errorPakomats || 'Lūdzu, izvēlieties pakomātu!' };
      } else {
        /* Attributes + note only. Do NOT add the free "Saņemšana" line item:
           requires_shipping=false → Admin shows "Shipping not required" and a
           Delete control on the Pakomāts property. Locker name belongs in
           order note_attributes (Additional details), not as a fake product. */
        data = null;
        cartAttributes[ATTR_PAKOMATS] = selectedTerminal;
        cartAttributes[ATTR_OMNIVA] = selectedTerminal;
        cartAttributes[ATTR_TERMINAL] = selectedTerminal;
        cartAttributes[ATTR_PIEGADE] = 'Omniva pakomāts';
        note = { mode: 'pakomats', terminal: selectedTerminal };
        try { localStorage.setItem('AIOO_selectedPakomats', selectedTerminal); } catch (e) {}
      }
    } else if (method === 'courier') {
      /* Attributes only — no fake Saņemšana line item. */
      data = null;
      cartAttributes[ATTR_PIEGADE] = 'Kurjers';
      note = { mode: 'clear' };
      try { localStorage.removeItem('AIOO_selectedPakomats'); } catch (e) {}
    } else if (method === 'pickup') {
      var storeSelect = container.querySelector('.js-store-pickup-select');
      var selectedStore = storeSelect ? String(storeSelect.value || '').trim() : '';
      if (!selectedStore && container.dataset.confirmedStore) {
        selectedStore = String(container.dataset.confirmedStore).trim();
        if (storeSelect && selectedStore) storeSelect.value = selectedStore;
      }
      if (!selectedStore) {
        if (storeSelect) {
          try { storeSelect.focus(); } catch (e) {}
        }
        return { ok: false, message: container.dataset.errorStore || 'Lūdzu, izvēlieties veikalu!' };
      }
      /* Attributes only. Checkout must use native Local Pickup (Pick up),
         not a Shopify shipping rate — then no home address is required. */
      data = null;
      cartAttributes[ATTR_PIEGADE] = 'Saņemšana veikalā';
      cartAttributes[ATTR_STORE] = selectedStore;
      note = { mode: 'store', store: selectedStore };
      try { localStorage.removeItem('AIOO_selectedPakomats'); } catch (e) {}
    } else {
      return { ok: false, message: container.dataset.errorMethod || 'Lūdzu, izvēlieties piegādes veidu!' };
    }

    try {
      if (localStorage.AIOO_selectedDevice) {
        cartAttributes['Lietotāja modelis'] = localStorage.AIOO_selectedDevice;
      }
    } catch (e) {}

    return {
      ok: true,
      payload: {
        data: data,
        cartAttributes: cartAttributes,
        note: note,
        method: method
      }
    };
  }

  function updateCartAttributesAndNote(payload) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var body = { attributes: payload.cartAttributes };
        if (payload.note && payload.note.mode === 'pakomats') {
          body.note = noteWithPakomats(cart.note, payload.note.terminal);
        } else if (payload.note && payload.note.mode === 'store') {
          body.note = noteWithStore(cart.note, payload.note.store);
        } else if (payload.note && payload.note.mode === 'clear') {
          body.note = noteWithoutPakomats(cart.note);
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/update.js ' + response.status);
        return response.json();
      });
  }

  function verifyOmnivaOnCart(cart, expectedTerminal) {
    var attrs = (cart && cart.attributes) || {};
    if (String(attrs[ATTR_PIEGADE] || '') === 'Saņemšana veikalā') return false;
    var terminal = String(
      attrs[ATTR_PAKOMATS] || attrs[ATTR_OMNIVA] || attrs[ATTR_TERMINAL] || ''
    ).trim();
    if (!terminal) return false;
    if (expectedTerminal && terminal !== String(expectedTerminal).trim()) return false;
    return true;
  }

  /* The hosted checkout never shows cart attributes, so the customer sees no sign of the locker or store
     picked here. Line item properties ARE listed under the product in the checkout summary, on the order
     and in the confirmation email, so mirror the choice onto the first product line as a visible note.
     /cart/change.js REPLACES the whole properties object, so every other property (e.g. the accessory
     "Device" note, O2O keys) is copied over and only our two keys are touched. Best effort: failures
     never block checkout, the cart attributes above stay the source of truth. */
  var PROP_LOCKER = 'Pakomāts';
  var PROP_STORE = 'Veikals';
  var SHIPPING_PRODUCT_HANDLE = 'pakomats';

  function lineItemPropertyChanges(cart, payload) {
    var items = (cart && cart.items) || [];
    var attrs = payload.cartAttributes || {};
    var wantLocker = payload.method === 'omniva' ? String(attrs[ATTR_PAKOMATS] || '') : '';
    var wantStore = payload.method === 'pickup' ? String(attrs[ATTR_STORE] || '') : '';
    var target = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle !== SHIPPING_PRODUCT_HANDLE) { target = i; break; }
    }
    var changes = [];
    items.forEach(function (item, index) {
      var current = item.properties || {};
      var next = {};
      Object.keys(current).forEach(function (key) {
        if (key !== PROP_LOCKER && key !== PROP_STORE) next[key] = current[key];
      });
      if (index === target) {
        if (wantLocker) next[PROP_LOCKER] = wantLocker;
        if (wantStore) next[PROP_STORE] = wantStore;
      }
      var had = String(current[PROP_LOCKER] || '') + '|' + String(current[PROP_STORE] || '');
      var will = String(next[PROP_LOCKER] || '') + '|' + String(next[PROP_STORE] || '');
      if (had !== will) changes.push({ line: index + 1, quantity: item.quantity, properties: next });
    });
    return changes;
  }

  function applyLineItemProperties(cart, payload) {
    var changes = lineItemPropertyChanges(cart, payload);
    if (!changes.length) return Promise.resolve(cart);
    var latest = cart;
    return changes
      .reduce(function (chain, body) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (response) {
            if (!response.ok) throw new Error('cart/change.js ' + response.status);
            return response.json();
          }).then(function (updated) {
            if (updated && updated.items) latest = updated;
          });
        });
      }, Promise.resolve())
      .then(function () { return latest; })
      .catch(function (err) {
        console.error('Delivery note on the cart line failed:', err);
        return latest;
      });
  }

  function submit(payload, container) {
    var expected =
      payload.method === 'omniva'
        ? (payload.cartAttributes && payload.cartAttributes[ATTR_PAKOMATS]) || ''
        : '';

    return Promise.resolve()
      .then(function () {
        return container ? sweepStaleShippingVariants(container) : null;
      })
      .then(function () {
        if (!payload.data) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload.data)
        }).then(function (response) {
          if (!response.ok) throw new Error('cart/add.js ' + response.status);
          return response.json();
        });
      })
      .then(function () {
        return updateCartAttributesAndNote(payload);
      })
      .then(function (cart) {
        if (payload.method === 'omniva' && !verifyOmnivaOnCart(cart, expected)) {
          throw new Error('Omniva pakomāts was not saved to cart attributes');
        }
        return applyLineItemProperties(cart, payload);
      });
  }

  /** Storefront guard: never open /checkout without a saved delivery choice. */
  function guardCheckoutLinks() {
    if (document.documentElement.dataset.aiooShippingGuard === '1') return;
    document.documentElement.dataset.aiooShippingGuard = '1';

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target && event.target.closest
          ? event.target.closest('a[href*="/checkout"]')
          : null;
        if (!link) return;
        if (link.hasAttribute('data-aioo-cart-page')) return;
        if (link.id === 'CartDrawer-Checkout' || link.id === 'inlinecheckout-cart') return;

        event.preventDefault();
        event.stopPropagation();
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      },
      true
    );
  }

  guardCheckoutLinks();

  window.AIOOShippingPicker = {
    init: init,
    collect: collect,
    submit: submit,
    verifyOmnivaOnCart: verifyOmnivaOnCart,
    lineItemPropertyChanges: lineItemPropertyChanges,
    sweepStaleShippingVariants: sweepStaleShippingVariants,
    showInlineError: showInlineError
  };
})();
